import baseApi from './base.api';
export default {
    ...baseApi,
    resource: 'MidiaAnotacaoUsuario',
};
